import styled from 'styled-components';

import { DESKTOP_WIDTH, HEADER_HEIGHT } from '~constant/layout';

export const Wrapper = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
  z-index: 1128;
  background-color: ${({ theme }) => theme.colors.white100};
`;

export const InnerWrapper = styled.div`
  display: flex;
  align-items: center;
  width: ${DESKTOP_WIDTH}px;
  height: ${HEADER_HEIGHT}px;
  margin: 0 auto;
  position: relative;
  background: #fff;

  ${({ theme }) => theme.media.with('mobile', 'tablet')} {
    width: 100%;
    padding: 0 3px 0 16px;
  }

  ${({ theme }) => theme.media.tablet} {
    padding: 0 20px 0 32px;
  }
`;

export const Logo = styled.div`
  img {
    vertical-align: top;
  }
`;
